const customMapModule = () => import(/* webpackChunkName: 'components/customMap' */'../../map/map');

import {templateCountrySite} from './countrysiteTpl';

/**
 * @class countrySiteView
 * @name countrySiteView
 * @augments Backbone.View
 * @see Backbone.View
 */
export const CountrySiteView = Backbone.View.extend({
  events: {
    'click .js_parkValidation': 'parkValidation',
    'click .js-countryCheckbox input': 'selectDomain'
  },

  /**
   * Init CountrySite view
   * @param {Object} options
   * @param {Model} options.model
   * @param {HTMLElement} options.element
   */
  initialize: function (options) {
    this.setElement(options.element);
    this.$countryList = $('.js-searchForm-countryList');
    this.hasCountryList = typeof FACETTE_COUNTRY_SCRIPTS !== 'undefined';
    this.wordings = SEARCH_SCRIPTS.WORDING_SEARCH;
    this.model = options.model;
    this.mainEngineModel = this.model.get('mainSearch');
    this.temporaryModel = this.model.get('temporarySearch');
    this.initListener();
    this.initSelectAll();
    this.initselectParks(true);
    this.parkValidation(true, true, true);
    this.handlePinBehaviour();
  },

  initListener: function () {
    this.stopListening(dispatcher, 'facette:countrysite:render');
    this.listenTo(dispatcher, 'facette:countrysite:render', this.render);

    this.stopListening(dispatcher, 'facette:countrysite:domainPreselection');
    this.listenTo(dispatcher, 'facette:countrysite:domainPreselection', this.domainPreselection);

    this.stopListening(dispatcher, 'facette:countrysite:parkValidation');
    this.listenTo(dispatcher, 'facette:countrysite:parkValidation', this.parkValidation);
  },

  /**
   * hiding all non-search content to show correctly searchList for mobile
   * (because of scroll-needing content, we can't use fixed position)
   * @param {boolean} firstLoad
   */
  initselectParks(firstLoad = false) {
    // Handling specific mobile behaviour
    const $optionListToggle = $('.js-optionListToggle');
    if (DEVICE.isMobile) {
      $optionListToggle.click(function () {
        if ($(this).hasClass('opened')) {
          $(this).removeClass('opened');
          $(this).next('.searchForm-optionsList').hide(300);
        } else {
          $(this).addClass('opened');
          $(this).next('.searchForm-optionsList').show(300);
        }
      });
    } else {
      $optionListToggle.off('mouseenter').on('mouseenter', function (event) {
        let $target = $(event.currentTarget);
        $optionListToggle.each(function (index, elt) {
          if ($(elt).data('id') !== $target.data('id')) {
            $(elt).removeClass('opened');
          }
        });
        $('.searchForm-optionsList').hide(0);
        $target.addClass('opened');
        if ($target.hasClass('opened')) {
          $target.next('.searchForm-optionsList').show(0);
        }
      });
    }

    // Handling custom map
    customMapModule().then(({customMap}) => {
      customMap.init('', '.api_customMap.countryMap-container');
    });

    // Handling country open by default
    if (!FACETTE_COUNTRY_SCRIPTS.COUNTRY_OPEN && firstLoad) {
      $($('.searchForm-parkSelectContainer .searchForm-country:not(.u-disabled) .searchForm-countryOptionsList')[0]).show(0);
      $($('.searchForm-parkSelectContainer .searchForm-country:not(.u-disabled) .js-optionListToggle')[0]).addClass('opened');
    }

    // Handling distance button and labels
    geoloc.distance.init(this.model);
  },

  initSelectAll() {
    $('.js-checkbox-selectAll input').off('change').on('change', event => {
      const $target = $(event.target);
      this.selectAll($target);
    });
  },

  /**
   * Select all checkboxes
   * @param {HTMLElement} $target
   * @param {String} origin
   */
  selectAll($target, origin = 'country-checkbox') {
    const status = $target.is(':checked'),
      itemValue = $target.val(),
      selectorClass = '.js-country_' + itemValue.split('_')[1];//value de la forme l1_ + code country

    if (!this.abortSeeAll) {
      //on coche toutes les checkbox du pays
      $(selectorClass + ' .js-countryCheckbox input').prop('checked', status).attr('checked', status);
    }

    // On met à jour la quantité pour le pays uniquement s'il s'agit d'un clic sur la checkbox country
    // (sinon, c'est le updateDomainQuantity du clic sur la checkbox domain qui s'en occupe)
    if (origin === 'country-checkbox') {
      let quantityTag = $target.closest('.searchForm-country').find('.js-quantity');
      this.updateDomainQuantity($(selectorClass), quantityTag);
    }
    if (!this.abortSeeAll) {
      this.parkValidation(false, false, false);
    }
  },

  /**
   * Handling domain checkbox behaviours
   */
  selectDomain(event) {
    const $target = $(event.currentTarget),
      quantity = $target.closest('.searchForm-country').find('.js-quantity'),
      _parent = $target.closest('.searchForm-optionsList');

    this.updateDomainQuantity(_parent, quantity);
    this.parkValidation(false, false, false);
  },

  /**
   * Handling displayed datas on checkbox events
   * NB : the parkvalidation is launch on autoclosure, because there's no more park validation button on desktop and tablet
   * @param {Boolean} init
   * @param {Boolean} closeList
   */
  parkValidation(init = false, closeList = true, silent = false) {
    const initParks = typeof init === 'boolean' ? init : false,
      $countryCheckboxInputChecked = $('.js-countryCheckbox input:checked'),
      nbDomains = $countryCheckboxInputChecked.length,
      $checkboxSelectAllInputChecked = $('.js-checkbox-selectAll input:checked'),
      nbSelectAll = $checkboxSelectAllInputChecked.length,
      $input = $('.js-facette_country_site'),
      $selector = $('.js-domainSelector .js_data, #searchToggler-domaines'),
      placeholder = $('.js-domainSelector .js_data').data('placeholder'),
      countrySelector = nbSelectAll > 0 ? '.js-' + $checkboxSelectAllInputChecked.val().replace('l1', 'country') : undefined,
      nbDomainsForFirstSelectAllChecked = typeof countrySelector !== 'undefined' ? $(countrySelector + ' .js-countryCheckbox input').length : 0,
      nbDomainsCheckedForFirstSelectAllChecked = typeof countrySelector !== 'undefined' ? $(countrySelector + ' .js-countryCheckbox input:checked').length : 0;

    let inputValue,
      labelDomain = nbDomains + ' ' + (nbDomains === 1 ? this.wordings.park : this.wordings.parks);

    if (nbSelectAll === 0 && nbDomains === 0) {
      // Aucun choix sélectionné => on affiche le placeholder
      $selector.html(placeholder);
    } else if (nbSelectAll === 1 && nbDomains === nbDomainsForFirstSelectAllChecked && nbDomains === nbDomainsCheckedForFirstSelectAllChecked) {
      // Si un seul pays complet => on affiche le nom du pays dans le select
      $input.val($(countrySelector + '-input').val());
      labelDomain = labelDomain + ' (' + $(countrySelector + '-input').data('label') + ')';
      $selector.html(labelDomain);
    } else if (nbDomains === 1) {
      // Un seul domaine coché => on affiche le nom du domaine dans le select
      $input.val($countryCheckboxInputChecked.val());
      $selector.html($countryCheckboxInputChecked.next('label').children('.js_siteLabel').text().trim());
    } else if (nbDomains > 0) {
      // Mix de domaines cochés => on affiche le nombre de domaines cochés
      $selector.html(labelDomain);
    }

    // Update model
    let oParks = {},
      oParksDisabled = {},
      arrParksStore = [];

    $('.searchForm-countryList .searchForm-country').each((index, country) => {
      const $inputSiteList = $(country).find('.js-countryCheckbox input'),
        nbSite = $inputSiteList.length,
        nbSiteChecked = $(country).find('.js-countryCheckbox input:checked').length,
        countryInput = $(country).find('.facette_country_site'),
        countryValue = countryInput.val();
      let addSites = true;

      if (nbSite === nbSiteChecked) {
        oParks[countryValue] = true;

        addSites = false;

        const oPark = {
          'key': countryValue,
          'code': countryValue.split('_')[1],
          'value': ''
        };
        arrParksStore.push(oPark);
      }

      if (countryInput.data('disable') === 'disabled') {
        oParksDisabled[countryValue] = true;
      }

      $inputSiteList.each(function (index, elt) {
        inputValue = $(elt).val();
        if ($(elt).is(':checked') && addSites) {
          oParks[inputValue] = true;

          if ($(elt).is(':disabled')) {
            oParksDisabled[inputValue] = true;
          }

          const oPark = {
            'key': inputValue,
            'code': inputValue.split('_')[1],
            'value': ''
          };
          arrParksStore.push(oPark);
        }
      });
    });

    // S'il n'y a qu'un domaine de sélectionné, update du search engine
    const nbCheckedDomains = $countryCheckboxInputChecked.length,
      nbMemorisedParks = Object.keys(this.temporaryModel.get('parks')).length;

    if (nbCheckedDomains === 1 || nbMemorisedParks === 1) {
      this.updateSearchTarget(true);
    }

    if (initParks) {
      if (!$.isEmptyObject(oParks)) {
        const modelData = {
          'hasDefaultSite': true,
          'parks': oParks,
          'parksDisabled': oParksDisabled
        };

        this.mainEngineModel.set(modelData, {'silent': true});
        this.temporaryModel.set(modelData, {'silent': true});

        this.updateSearchTarget(true);
      }
    } else {
      // S'il n'y a pas de changement dans le model, on se contente de cacher le loader
      if (JSON.stringify(this.temporaryModel.get('parks')) !== JSON.stringify(oParks)) {
        this.temporaryModel.set({
          'parks': oParks,
          'parksDisabled': oParksDisabled
        }, {silent});

        if ($.isEmptyObject(oParks)) {
          oParks = null;
        }
        dispatcher.trigger('search:updateMainSearchStore', 'countrysite', arrParksStore);
      }
    }

    // Contrôle au cas où aucun pays ne soit ouvert par défaut
    if ($('.searchForm-country .searchForm-listHeader.opened').length === 0) {
      $('.searchForm-country:not(.u-disabled) .searchForm-listHeader').first().addClass('opened');
      $('.searchForm-country:not(.u-disabled) .searchForm-optionsList').first().show(0);
    }

    if (closeList) {
      dispatcher.trigger('searchView:closeLists');
    }
  },

  /**
   * Handling design modification related to pin on map
   */
  handlePinBehaviour() {
    $('.js-countryCheckbox input, .js-countryCheckbox label, .js-searchForm-sitePin')
      .off('mouseover mouseout')
      .on('mouseover mouseout', event => {
        const item = event.currentTarget;
        let pinId = $(item).val();
        if (item.tagName === 'LABEL') {
          pinId = $(item).closest('div.form-checkboxContainer').find('input.form-checkbox').val().split('_')[1];
        } else if (item.tagName === 'SPAN') {
          pinId = item.id.substr(4);
        }

        $('.searchForm-countryOptionsList').find('div.form-checkboxContainer input[value =' + pinId + '] + label').toggleClass('hover', event.type === 'mouseover');
        $('#pin_' + pinId).toggleClass('hover', event.type === 'mouseover');
      });

    $('.js-searchForm-sitePin').off('click').on('click', event => {
      const targetInput = $(event.currentTarget).data('input');
      $(targetInput).click();
    });
  },

  /**
   * Handling design for pin on the map
   * @param {String|Element} country
   */
  updateCheckboxDesign(country) {
    const countryCheckboxes = $(country).find('.js-countryCheckbox input');
    $(countryCheckboxes).each((index, item) => {
      const $targetPin = $('#pin_' + $(item).val());
      $targetPin.toggleClass('checked', $(item).prop('checked'));
    });
  },

  /**
   * Handle number of selected domain for each country (mobile)
   * and alter checked status for selectAll checkbox
   * @param {String|Element} countrySelector
   * @param {String|Element} quantityTag
   */
  updateDomainQuantity: function (countrySelector, quantityTag) {
    const checkedDomainsList = $(countrySelector).find('.js-countryCheckbox input:checked'),
      nbCheckedDomains = checkedDomainsList.length,
      nbDomains = $(countrySelector).find('.js-countryCheckbox input').length,
      $seeAllCheckbox = DEVICE.isMobile ? $($(countrySelector).find('.js-checkbox-selectAll input')) : $($(countrySelector).closest('.searchForm-country').find('.js-checkbox-selectAll input')),
      nbOverallCheckedDomains = $('.js-countryCheckbox:not(.u-disabled) input:checked').length;

    // Update quantity for this country
    $(quantityTag).html(nbCheckedDomains);
    if (nbCheckedDomains > 0) {

      $(quantityTag).show(0);

      $('.js-country .submitContainer a').removeClass('u-disabled');

      // Handling see all status
      this.abortSeeAll = true; // Disable chained action on domain checkboxes
      $seeAllCheckbox.prop('checked', nbCheckedDomains === nbDomains).attr('checked', nbCheckedDomains === nbDomains);
      this.selectAll($seeAllCheckbox, 'domain-checkbox');
      this.abortSeeAll = false; // Enable chained action on domain checkboxes

      this.updateSearchTarget();
    } else {
      if (nbOverallCheckedDomains > 0) {
        this.updateSearchTarget();
      }

      $(quantityTag).hide(0);

      $seeAllCheckbox.prop('checked', false).attr('checked', false);
      // Désactivation du bouton de submit country pour la version mobile, lorsqu'il n'y a aucun parc de sélectionné
      if ($('.js-countryCheckbox input:checked').length === 0 && Object.keys(this.temporaryModel.get('parks')).length === 0) {
        $('.js-country .submitContainer .buttonContainer').addClass('u-disabled');
      }
    }
    this.updateCheckboxDesign(countrySelector);
  },

  /**
   * Update the search engine action, in regards to country domain value
   */
  updateSearchTarget() {
    // if only one domain, the search form point on domain page
    if (!this.hasResultsList) {
      const checkedDomainsList = $('.js-countryCheckbox input:checked'),
        nbCheckedDomains = checkedDomainsList.length;

      if (nbCheckedDomains === 1) {
        const arrSiteUrl = FACETTE_COUNTRY_SCRIPTS.ARR_SITE_URL,
          productCode = $(checkedDomainsList)[0].value.split('_')[1],
          targetUrl = typeof productCode !== 'undefined' ? arrSiteUrl[productCode] : SEARCH_SCRIPTS.URL_SEARCH + '?';

        this.model.set({
          'url_searchTarget': targetUrl + '?',
          'sort': 'popularity_housing'
        }, {'silent': true});
      } else {
        const sort = this.model.get('sort'),
          newSort = sort === 'popularity_housing' ? this.model.defaults.sort : sort;
        this.model.set({
          'url_searchTarget': SEARCH_SCRIPTS.URL_SEARCH + '?',
          'sort': newSort
        }, {'silent': true});
      }
    }
  },

  /**
   * Check selected domain on facette opening
   */
  domainPreselection() {
    const $link = $('.js-domainSelector');

    //uncheck all domains
    $('.js-country .searchForm-dataList input').each((index, elt) => {
      $(elt).prop('checked', false).attr('checked', false);
    });

    //flag parent
    $link.closest('.searchForm-parkSelectContainer').toggleClass('opened');

    //check selected domains
    $.each(this.temporaryModel.get('parks'), key => {
      $('.js-country .searchForm-dataList input[value="' + key + '"]').prop('checked', true).attr('checked', true);

      if (key.indexOf('l1') > -1) {//si checkbox country => on check tous les inputs des sites du pays
        $('.js-country_' + key.split('_')[1] + ' input').prop('checked', true).attr('checked', true);
      }
    });

    $('.js-country .js-optionListToggle').each((index, elt) => {
      const country = '.js-country_' + $(elt).data('key'),
        quantityTag = $(elt).find('.js-quantity');
      this.updateDomainQuantity(country, quantityTag);
    });
  },

  /**
   * Renter the view
   * @param {Object} facette
   */
  render: function (facette) {
    this.$countryList.html(templateCountrySite(facette, SEARCH_SCRIPTS.WORDING_SEARCH, FACETTE_COUNTRY_SCRIPTS.COUNTRIES_COORDINATES, GLOBAL_SCRIPTS.STATIC_VERSION));
    this.parkValidation(false, false);
    this.initselectParks();
    this.initSelectAll();
    this.handlePinBehaviour();
  }
});